export function windowExists() {
    return typeof window !== 'undefined';
}
export function windowHasFeature(feature) {
    return windowExists() && feature in window;
}
//# sourceMappingURL=window.js.map